import { Pagination } from "../types/PaginiationResult";
import { AxiosInstance } from "axios";
import { QueueItem, QueueItemSummary } from "../types/Queue/QueueItem";
import { ListQueueItemsParams } from "../types/Queue/ListQueueItemsParams";
import { QueueSummary } from "../types/Queue/QueueSummary";
import { DateTime } from "luxon";
import { ProcessingTimes } from "../types/Queue/ProcessingTimes";

export default class QueueService {
  private _endpoint = "Queue";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public ListQueueItems(
    { queueStatus, page, pageSize }: ListQueueItemsParams,
    abortController?: AbortController,
  ): Promise<Pagination<QueueItemSummary>> {
    return this._client
      .get<any>(`${this._endpoint}`, {
        params: { queueStatus, page, pageSize },
        signal: abortController?.signal,
      })
      .then((response) => {
        return response.data;
      });
  }

  public GetQueueItem(
    deferredRequestId: string,
    abortController?: AbortController,
  ): Promise<QueueItem> {
    return this._client
      .get<any>(`${this._endpoint}/${deferredRequestId}`, {
        signal: abortController?.signal,
      })
      .then((response) => {
        return response.data;
      });
  }

  public GetQueueSummary(): Promise<QueueSummary> {
    return this._client
      .get<any>(`${this._endpoint}/Summary`)
      .then((response) => {
        return response.data;
      });
  }

  public Retry(orderItemId: string) {
    return this._client.post(`${this._endpoint}/${orderItemId}/Retry`);
  }

  public Fail(deferredRequestId: string) {
    return this._client.post(`${this._endpoint}/${deferredRequestId}/Fail`);
  }

  public ResolveFailedQueueItem(orderItemId: string) {
    return this._client.post(`${this._endpoint}/${orderItemId}/Resolve`);
  }

  public GetProcessingTimes(
    startDate: DateTime,
    endDate: DateTime,
    abortController?: AbortController,
  ): Promise<ProcessingTimes> {
    return this._client
      .get<any>(`${this._endpoint}/ProcessingTimes`, {
        params: {
          startDate: startDate.toFormat("yyyy-MM-dd"),
          endDate: endDate.toFormat("yyyy-MM-dd"),
        },
        signal: abortController?.signal,
      })
      .then((response) => {
        return response.data;
      });
  }
}
